export const ORG_TABS = ["About", "TEAMscan"] as const;
